export default __webpack_public_path__ + "static/dm-466757644ba07a8bbf786eae1222a578.svg";